module.exports = __webpack_public_path__ + "static/media/taxonomyApplication.c83c04c4.png";